<template>
  <div class="seomain">
    <st-header
      :title="formData.id ? '编辑付款单' : '添加付款单'"
      :back-able="true"
    >
    </st-header>
    <div class="st-form-content">
      <st-form ref="form">
        <!-- <div class="st-form-title">基本信息</div> -->
        <div class="st-form-group">

          <van-cell-group inset>
						<st-form-item key="order_type" label="付款单类型" prop="order_type" :required="true">
							<st-select
								v-model="formData.order_type"
								:defText="formData.order_type_text"
								name="付款单类型"
								placeholder="请选择付款单类型"
								:options="$option['getModelConf']('FinancePaymentOrder', 'orderType')"
								:clearable="true"
								:filterable="false"
								@change="ordertypeChange"
							>
							</st-select>
						</st-form-item>
						
						<st-form-item key="sales_code" v-if="salesShow" label="销售单号" prop="sales_code">
						  <st-select
						    v-model="formData.sales_code"
								:defText="formData.sales_code"
						    name="销售单号"
						    placeholder="请选择销售单号"
						    :options="$option['getSalesOrder']"
								:clearable="true"
								val-field="ordercode"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item 
							v-if="bankshow && purchaseShow"
							key="purchase_code" label="采购单号" prop="purchase_code"
						>
						  <st-select
						    v-model="formData.purchase_code"
								:defText="formData.purchase_code"
						    name="采购单号"
						    placeholder="请选择采购单号"
						    :options="$option['getPurchaseOrder']"
								:clearable="true"
								val-field="code"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item 
							v-if="rmaShow"
							key="rma_code" label="退换货单号" prop="rma_code"
						>
						  <st-select
						    v-model="formData.rma_code"
								:defText="formData.rma_code"
						    name="退换货单号"
						    placeholder="请选择退换货单号"
						    :options="$option['getRmaOrder']"
								:clearable="true"
								val-field="code"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item 
							v-if="applyTypeShow"
							key="apply_type" label="报销类型" prop="apply_type" :required="true"
						>
							<st-select
								v-model="formData.apply_type"
								:defText="formData.apply_type_text"
								name="报销类型"
								placeholder="请选择报销类型"
								:options="$option['getModelConf']('FinancePaymentOrder', 'applyType')"
								:clearable="true"
								:filterable="false"
							>
							</st-select>
						</st-form-item>
						
            <st-form-item key="type" label="付款方式" prop="type" :required="true">
              <st-select
                v-model="formData.type"
								:defText="formData.type"
                name="付款方式"
                placeholder="请选择付款方式"
                :options="$option['getModelConf']('FinancePaymentOrder', 'type')"
								:clearable="true"
								:filterable="false"
              >
              </st-select>
            </st-form-item>
						
						<st-form-item key="company_id" label="付款单位" prop="company_id" :required="true">
						  <st-select
						    v-model="formData.company_id"
								:defText="formData.company_name"
						    name="付款单位"
						    placeholder="请选择付款单位"
						    :options="$option['getCompanyList']"
								:clearable="true"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item key="predicttime" label="付款时间" prop="predicttime" :required="true">
							<st-date
								v-model="formData.predicttime"
								name="付款时间"
								placeholder="请选择付款时间"
							></st-date>
						</st-form-item>
						
						<st-form-item key="currency" label="币种" prop="currency" :required="true">
						  <st-select
						    v-model="formData.currency"
						    name="币种"
						    placeholder="请选择币种"
						    :options="$option['getCurrency']"
								:filterable="false"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item key="amount" label="收款金额" prop="amount" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.amount"
						    name="收款金额"
						    label=""
						    placeholder="请填写收款金额"
						  />
						</st-form-item>
						
						<st-form-item 
							v-if="bankshow"
							key="supplier_id" label="收款人" prop="supplier_id" :required="true"
						>
						  <st-select
						    v-model="formData.supplier_id"
								:defText="formData.supplier_name"
						    name="收款人"
						    placeholder="请选择收款人"
						    :options="$option['getSupplier']"
								:clearable="true"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item 
							v-if="clientShow"
							key="client_id" label="客户" prop="client_id"
						>
						  <st-select
						    v-model="formData.client_id"
								:defText="formData.client_name"
						    name="客户"
						    placeholder="请选择客户"
						    :options="$option['getCustomer']"
								:clearable="true"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item key="account_name" :label="formData.order_type == 12 || formData.order_type == 20 ? '收款人': '账户名称'" prop="account_name" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.account_name"
						    name="账户名称"
						    label=""
						    placeholder="请填写账户名称"
						  />
						</st-form-item>
						
					<st-form-item key="collection_bank" :label="formData.currency == 'USD' ? 'Bank Name' : '开户行'" prop="collection_bank" :required="true">
					  <van-field
					    class="st-form-item-input"
					    v-model="formData.collection_bank"
					    :name="formData.currency == 'USD' ? 'Bank Name' : '开户行'"
					    label=""
					    :placeholder="'请填写' + (formData.currency == 'USD' ? 'Bank Name' : '开户行')"
					  />
					</st-form-item>
					
					<st-form-item key="collection_account" :label="formData.currency == 'USD' ? 'Account NO' : '收款账号'" prop="collection_account" :required="true">
					  <van-field
					    class="st-form-item-input"
					    v-model="formData.collection_account"
					    :name="formData.currency == 'USD' ? 'Account NO' : '收款账号'"
					    label=""
					    :placeholder="'请填写' + (formData.currency == 'USD' ? 'Account NO' : '收款账号')"
					  />
					</st-form-item>
					
					<st-form-item 
						v-if="formData.currency == 'USD'" 
						key="swiftcode" label="SWIFTCODE" prop="swiftcode"
					>
					  <van-field
					    class="st-form-item-input"
					    v-model="formData.swiftcode"
					    name="SWIFTCODE"
					    label=""
					    placeholder="请填写SWIFTCODE"
					  />
					</st-form-item>
					
					<st-form-item 
						v-if="formData.currency == 'USD'" 
						key="collection_account_name" label="Account Name" prop="collection_account_name"
					>
					  <van-field
					    class="st-form-item-input"
					    v-model="formData.collection_account_name"
					    name="Account Name"
					    label=""
					    placeholder="请填写Account Name"
					  />
					</st-form-item>
					
					<st-form-item 
						v-if="formData.currency == 'USD'" 
						key="collection_bank_code" label="Bank Code" prop="collection_bank_code"
					>
					  <van-field
					    class="st-form-item-input"
					    v-model="formData.collection_bank_code"
					    name="Bank Code"
					    label=""
					    placeholder="请填写Bank Code"
					  />
					</st-form-item>
					
					<st-form-item 
						v-if="formData.currency == 'USD'"
						key="collection_company_add" label="Company Add" prop="collection_company_add"
					>
					  <van-field
					    class="st-form-item-input"
					    v-model="formData.collection_company_add"
					    name="Company Add"
					    label=""
					    placeholder="请填写Company Add"
					  />
					</st-form-item>
					
					<st-form-item 
						v-if="bankshow && formData.currency !== 'USD'"
						key="tax_identification_number" label="纳税识别号" prop="tax_identification_number" :required="true"
					>
					  <van-field
					    class="st-form-item-input"
					    v-model="formData.tax_identification_number"
					    name="纳税识别号"
					    label=""
					    placeholder="请填写纳税识别号"
					  />
					</st-form-item>
					
					<st-form-item key="degree" label="紧急程度" prop="degree" :required="true">
					  <st-select
					    v-model="formData.degree"
					    name="紧急程度"
					    placeholder="请选择紧急程度"
					    :options="$option['degree']"
							:clearable="true"
					  >
					  </st-select>
					</st-form-item>
					
            <st-form-item key="content" label="付款摘要" prop="content" :required="true">
							<van-field
								class="st-form-item-input"
								v-model="formData.content"
								name="付款摘要"
								label=""
								placeholder="请填写付款摘要"
							/>
            </st-form-item>
						
						<st-form-item key="certificate_images" label="附件" prop="certificate_images">
						  <st-file-upload
						    v-model="formData['certificate_images']"
						  >
						  </st-file-upload>
						</st-form-item>
          </van-cell-group>
        </div>
        
        <div style="margin: 16px;" class="form-submit-button">
          <van-button round block type="primary"  @click="onSubmit">
            提交
          </van-button>
        </div>
      </st-form>
    </div>
    
  </div>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StSelect from "@/components/Select.vue";
import StDate from "@/components/Date.vue";
import StHeader from "@/components/layout/Header.vue";
import StForm from "@/components/form.vue";
import StFormItem from "@/components/formItem.vue";
import formConf from "./conf/form.js";

export default {
  name: 'stSalesAdd',
  components: {
    'st-file-upload': StFileUpload,
    'st-select': StSelect,
    "st-header": StHeader,
    "st-form-item": StFormItem,
		StForm,
		StDate
  },
  props: {},
  data() {
    return {
      formRule: {},
      formData: {
				order_type: "",
				currency: 'CNY',
				amount: "",
				apply_type: "",
      }, 
      loading: false,
      actField: '',
      actOptions: [],
			conf: formConf,
			
			
			// 控制展示
			bankshow: false,
			purchaseShow: false,
			salesShow: false,
			rmaShow: false,
			clientShow: false,
			applyTypeShow: false,
    };
  },
  watch: {},
	computed: {},
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "添加付款单" });
    });
  },
  mounted() {},

  methods: {
    init() {
			let id = parseInt(this.$route.query.id);
			this.formData.id = isNaN(id) ? 0 : id;
			this.getUpdateData();
		},
		// 获取编辑需要显示的数据
		getUpdateData() {
			if (this.formData.id) {
				this.$post(`${this.$api.stPayOrderEditInfo}`, {id: this.formData.id}).then((res) => {
					let data = res.data;
					data.type = data.type * 1;
					data.degree = data.degree.toString();
					this.formData = data;
					this.ordertypeChange();
					this.$set(this.formData, ['purchase_code'], (this.purchaseShow && this.bankshow ? data.order_code : ''));
					this.$set(this.formData, ['sales_code'], (this.salesShow ? data.order_code : ''));
					this.$set(this.formData, ['rma_code'], (this.rmaShow ? data.order_code : ''));
				}).catch((err) => {
					window.history.go(-1);
					console.log('payorder/edit', err);
				});
			} else {
				this.ordertypeChange();
			}
		},

		// 订单类型更改
		ordertypeChange() {
			if (this.formData.order_type == 10) {
				this.applyTypeShow = true;
			} else {
				this.applyTypeShow = false;
			}
			
		 if ([11].includes(this.formData.order_type)) {
					this.rmaShow = true;
					this.purchaseShow = false;
					this.clientShow = true;
			} else {
					this.rmaShow = false;
					this.purchaseShow = true;
					this.clientShow = false;
			}

			if ([14, 19].includes(this.formData.order_type) ) {
					this.salesShow = true;
					
			} else {
					this.salesShow = false;
			}
			let arr = [7, 10, 1, 2, 11, 3, 12, 18, 14, 19,5,20];
			if(arr.includes(this.formData.order_type)) {
				 this.bankshow = false;
			} else {
				this.bankshow = true;
			}
			
			if ([11, '', 20].includes(this.formData.order_type)) {
				this.purchaseShow = false;
			} else {
				this.purchaseShow = true;
			}
			
			if (this.purchaseShow === false || this.bankShow === false) {
				this.formData.purchase_code = '';
			}
			
			if (!this.salesShow) {
				this.formData.sales_code = '';
			}
			
			if (!this.rmaShow) {
				this.formData.rma_code = '';
			}
		},

    // 提交表单
    onSubmit() {
     this.$refs.form.validater.valid((isValid, lastError) => {
        if (!isValid) {
          this.$toast.fail('表单异常：' + lastError);
        }
      });
			
      let formData = JSON.parse(JSON.stringify(this.formData));
			if(this.clientShow) {
				formData.supplier_id = formData.client_id;
			}
			formData['certificate_images'] = formData['certificate_images'].map((item) => { return item.url; }).join(',');
			if (this.formData.id) {
				this.updateData(formData);
			} else {
				this.addData(formData);
			}
      
    },
		
		addData(formData) {
			this.$post(this.$api.stPayOrderAdd, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '创建异常');
			  } else {
			    this.$toast.success("创建成功");
			    this.$router.replace(`/payorder/list`);
			  }
			});
		},
		updateData(formData) {
			this.$post(this.$api.stPayOrderEdit, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '编辑异常');
			  } else {
			    this.$toast.success("编辑付款单成功");
			    this.$router.replace(`/payorder/list`);
			  }
			});
		},
  },
};
</script>

<style lang="scss" scoped>
.st-form-content {
  margin: 20px 15px;
	form {
		overflow: hidden;
	}
	
  .st-form-title {
    border-radius: 5px 5px 0px 0px;
    padding: 20px 21px;
    font-size: 20px;
    background-color: rgb(207, 212, 217);

    .st-van-btn-info {
      float: right;
    }
  }
  .st-form-group {
    background-color: white;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
		padding-bottom: 16px;
		border-radius: 5px;
    
    .st-van-filed-label-imp {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }
    
    .van-field {
      box-shadow: inset 0 0 0 2px rgb(223,223,223);
      border-radius: 5px;
    }

    .form-submit-button {
      margin-top: 12px;
    }

  }

}

</style>
